/* lkp2.js - Lush Keepsake personaliser v2, part 1 of 14 (readable source: build/src/lkp2.js; split by build/minify.py) */
(function(){'use strict';var K=window.__lkp2k=window.__lkp2k||{};
var D = window.LKP2DATA || { FONTS: [], ICONS: { lk24: {}, sports: {} }, ICON_NAMES: { lk24: {}, sports: {} }, LIBS: {}, STYLE_FONTS: {} };
if (D.ICONS2) { D.ICONS = D.ICONS || {}; Object.keys(D.ICONS2).forEach(function (k) { D.ICONS[k] = D.ICONS2[k]; }); }
var DASH = ' - '; // property names use a plain ASCII hyphen ("Front - line 1") for the engraving team
var EN = ' ' + String.fromCharCode(8211) + ' '; // en dash: still read when prefilling lines added by the first version
var SEP_RE = new RegExp(' [-' + String.fromCharCode(8211) + '] ');
var POUND_FMT = null;
var EMAIL = 'hello@lushkeepsake.com';
var BLANK_DEFAULT = ['blank', 'no engraving', 'not engraved', 'no engrav', 'sample', 'none', '0 side', 'no code', 'unengraved'];
var NUM_WORDS = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, both: 2, single: 1, double: 2 };
var SWATCH = { silver: '#d4d7dc', gold: '#e2c26b', 'rose gold': '#e8b4a0', rose: '#e8b4a0', black: '#26272b', 'gun metal': '#4a4c52',
blue: '#2f63a8', navy: '#1d2740', red: '#b02a2a', white: '#ffffff', pink: '#f0a6bf', purple: '#5d3f78', green: '#2f7a42',
brown: '#7a4a2a', tan: '#b88356', wood: '#a0703f', walnut: '#6b4428', yellow: '#f2cd2b' };
var INK_DARK = { walnut: '#2a1608', wood: '#2a1608', leather: '#2a1608', _: '#0a0a0a' };
var INK_LIGHT = '#ffffff';
var CAP = 0.7; // cap height / em, used for legibility maths
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
function h(tag, attrs, html) {
var e = document.createElement(tag);
if (attrs) for (var k in attrs) { if (attrs[k] === false || attrs[k] == null) continue; if (k === 'class') e.className = attrs[k]; else e.setAttribute(k, attrs[k] === true ? '' : attrs[k]); }
if (html != null) e.innerHTML = html;
return e;
}
function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
function clone(o) { return o == null ? o : JSON.parse(JSON.stringify(o)); }
function lc(s) { return String(s == null ? '' : s).toLowerCase().trim(); }
function isObj(o) { return o && typeof o === 'object' && !Array.isArray(o); }
function merge(a, b) {
if (!isObj(a) || !isObj(b)) return clone(b);
var out = clone(a);
Object.keys(b).forEach(function (k) {
if (k === 'faces' && Array.isArray(a.faces) && Array.isArray(b.faces)) {
var list = clone(a.faces);
b.faces.forEach(function (f) {
var i = -1; list.forEach(function (x, j) { if (x.id === f.id) i = j; });
if (i >= 0) list[i] = merge(list[i], f); else list.push(clone(f));
});
out.faces = list.filter(function (f) { return !f.remove; });
} else if (isObj(a[k]) && isObj(b[k])) out[k] = merge(a[k], b[k]);
else out[k] = clone(b[k]);
});
return out;
}
function firstInt(v) {
var s = lc(v); var m = s.match(/\d+/);
if (m) return parseInt(m[0], 10);
for (var w in NUM_WORDS) if (new RegExp('\\b' + w + '\\b').test(s)) return NUM_WORDS[w];
return null;
}
function money(cents) {
try {
if (!POUND_FMT) POUND_FMT = new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' });
return POUND_FMT.format(cents / 100);
} catch (e) { return String.fromCharCode(163) + (cents / 100).toFixed(2); }
}
function hash(s) { var x = 2166136261; for (var i = 0; i < s.length; i++) { x ^= s.charCodeAt(i); x = Math.imul(x, 16777619); } return x >>> 0; }
function debounce(fn, ms) { var t; return function () { var a = arguments, me = this; clearTimeout(t); t = setTimeout(function () { fn.apply(me, a); }, ms); }; }
function cleanLabel(l) { return String(l || '').replace(/\s*\((optional|required)\)\s*$/i, '').trim(); }
function fontByN(n) { n = parseInt(n, 10) || 1; for (var i = 0; i < D.FONTS.length; i++) if (D.FONTS[i].n === n) return D.FONTS[i]; return D.FONTS[0] || { n: 1, name: 'Arial', css: 'Arial, sans-serif' }; }
function swatchFor(name) {
var k = lc(name);
if (SWATCH[k]) return SWATCH[k];
if (k.indexOf('&') > 0 || k.indexOf(' and ') > 0) {
var p = k.split(/\s*(?:&|and)\s*/); return 'linear-gradient(135deg,' + (SWATCH[p[0]] || '#ccc') + ' 50%,' + (SWATCH[p[1]] || '#ccc') + ' 50%)';
}
for (var s in SWATCH) if (k.indexOf(s) >= 0) return SWATCH[s];
return '#cfd3d8';
}
function inkFor(tone, colourName) {
if (tone && tone.charAt(0) === '#') return tone;
if (tone === 'light') return INK_LIGHT;
var k = lc(colourName);
for (var s in INK_DARK) if (s !== '_' && k.indexOf(s) >= 0) return INK_DARK[s];
return INK_DARK._;
}
var CFG = {};
function loadConfig(url) {
if (!url) return Promise.resolve(null);
if (!CFG[url]) CFG[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
return CFG[url];
}
var IMG = {};
function loadImg(src) {
if (!IMG[src]) IMG[src] = new Promise(function (res, rej) {
var im = new Image();
if (/^https?:/.test(src) && src.indexOf(location.host) < 0) im.crossOrigin = 'anonymous';
im.decoding = 'async';
im.onload = function () { res(im); };
im.onerror = function () { rej(new Error('img ' + src)); };
im.src = src;
});
return IMG[src];
}
var ART_INK = { silver: ['#2e3238', 'dark'], gold: ['#3e2c0c', 'dark'], rose: ['#4d2a20', 'dark'], black: ['#e9eaec', 'light'], walnut: ['#21120a', 'dark'],
white: ['#3a3a3c', 'dark'], brown: ['#3a1f0e', 'dark'], orange: ['#5a2a0c', 'dark'], red: ['#4a0c0e', 'dark'], pink: ['#7a3346', 'dark'], blue: ['#14284a', 'dark'],
green: ['#16301b', 'dark'], gray: ['#3a3b3e', 'dark'], grey: ['#3a3b3e', 'dark'], coffee: ['#2e261c', 'dark'], navy: ['#0e1424', 'dark'], yellow: ['#5a4410', 'dark'],
teal: ['#0f3334', 'dark'], tan: ['#4a2a10', 'dark'], _: ['#2e3238', 'dark'] };
var ARTTXT = {}, ARTIMG = {};
function artBaseUrl(root) {
var b = root && root.getAttribute('data-art-base');
if (!b) { var s = document.querySelector('script[src*="/lkp2.js"]'); b = s ? s.src.replace(/lkp2\.js(\?.*)?$/, '') : '/assets/'; }
return b.indexOf('//') === 0 ? location.protocol + b : b;
}
function artText(baseUrl, id, fin, month) {
var key = id + '.' + fin + (month ? '.' + month : '');
if (!ARTTXT[key]) {
var A = window.LKP2ART || {}, up = (A.up && A.up[id]) || [], own = up.indexOf(fin) >= 0 || !A.base || !A.base[id] || A.base[id] === fin;
var src = own ? fin : A.base[id], map = own ? null : (A.pal || {})[src + '>' + fin];
ARTTXT[key] = fetch(baseUrl + 'lka-' + id + '.' + src + '.svg' + (A.v ? '?v=' + A.v : ''), { credentials: 'same-origin' }).then(function (r) {
if (!r.ok) throw new Error('art ' + id + '.' + src + ' ' + r.status);
return r.text();
}).then(function (t) {
if (map && A.tok) t = t.replace(new RegExp(A.tok, 'g'), function (s) { return map[s] || s; });
var st = A.stones, mc = month && st && st.m && st.m[month];
if (mc) st.s.forEach(function (c, i) { t = t.replace(new RegExp(c, 'gi'), mc[i]); });
return t;
});
ARTTXT[key]['catch'](function () { delete ARTTXT[key]; });
}
return ARTTXT[key];
}
function artRaster(baseUrl, id, fin, R, month) {
var key = id + '.' + fin + (month ? '.' + month : '') + '@' + R;
if (!ARTIMG[key]) {
ARTIMG[key] = artText(baseUrl, id, fin, month).then(function (t) {
var url = URL.createObjectURL(new Blob([t], { type: 'image/svg+xml' }));
return loadImg(url).then(function (im) {
var w0 = im.naturalWidth || 1600, h0 = im.naturalHeight || 1600, c = document.createElement('canvas');
c.width = R; c.height = Math.round(R * h0 / w0);
var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(im, 0, 0, c.width, c.height);
return c;
});
});
ARTIMG[key]['catch'](function () { delete ARTIMG[key]; });
}
return ARTIMG[key];
}
var MOTIF = {};
function motifImg(baseUrl, id) {
if (!MOTIF[id]) {
var A = window.LKP2ART || {};
MOTIF[id] = fetch(baseUrl + 'lkm-' + id + '.svg' + (A.mv ? '?v=' + A.mv : ''), { credentials: 'same-origin' }).then(function (r) {
if (!r.ok) throw new Error('motif ' + id + ' ' + r.status);
return r.text();
}).then(function (t) {
var vb = /viewBox="([\d.\s-]+)"/.exec(t), n = vb ? vb[1].trim().split(/\s+/).map(parseFloat) : [0, 0, 100, 100];
t = t.replace(/currentColor/g, '#000').replace('<svg ', '<svg width="' + Math.round(n[2] * 12) + '" height="' + Math.round(n[3] * 12) + '" ');
return loadImg(URL.createObjectURL(new Blob([t], { type: 'image/svg+xml' })));
});
MOTIF[id].then(function (im) { MOTIF[id].done = im; }, function () { delete MOTIF[id]; });
}
return MOTIF[id];
}
var MAPS = {};
function mapNorm(s) { return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, ''); }
function mapDist(a, b, max) {
if (Math.abs(a.length - b.length) > max) return max + 1;
var d = [], i, j;
for (i = 0; i <= a.length; i++) d[i] = [i];
for (j = 0; j <= b.length; j++) d[0][j] = j;
for (i = 1; i <= a.length; i++) {
var rowMin = 1e9;
for (j = 1; j <= b.length; j++) {
d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
rowMin = Math.min(rowMin, d[i][j]);
}
if (rowMin > max) return max + 1;
}
return d[a.length][b.length];
}
function mapJson(baseUrl, name) {
if (!MAPS[name]) {
var A = window.LKP2ART || {};
MAPS[name] = fetch(baseUrl + name + (A.mpv ? '?v=' + A.mpv : ''), { credentials: 'same-origin' }).then(function (r) {
if (!r.ok) throw new Error(name + ' ' + r.status);
return r.json();
});
MAPS[name].then(function (j) { MAPS[name].done = j; }, function () { delete MAPS[name]; });
}
return MAPS[name];
}
function mapFind(ix, txt) {
var n = mapNorm(txt); if (!n || !ix || !ix.keys) return null;
if (!ix._n) {
ix._n = {};
Object.keys(ix.keys).forEach(function (k) { ix._n[mapNorm(k)] = k; });
Object.keys(ix.alias || {}).forEach(function (a) { if (!ix._n[mapNorm(a)] && ix.keys[ix.alias[a]] != null) ix._n[mapNorm(a)] = ix.alias[a]; });
}
if (ix._n[n]) return ix._n[n];
if (ix._n[n.replace(/^the/, '')]) return ix._n[n.replace(/^the/, '')];
var best = null, bd = 99, max = n.length <= 4 ? 0 : n.length <= 7 ? 1 : 2;
if (!max) return null;
Object.keys(ix._n).forEach(function (k) { var dd = mapDist(n, k, max); if (dd <= max && dd < bd) { bd = dd; best = ix._n[k]; } });
return best;
}
function mapPlace(baseUrl, txt) {
var ip = mapJson(baseUrl, 'lkm-index.json');
var bundle = function (ix) { var key = mapFind(ix, txt); return key ? { key: key, file: ix.files[ix.keys[key]] } : null; };
if (!ip.done) return { pending: ip.then(function (ix) { var b = bundle(ix); return b ? mapJson(baseUrl, b.file) : null; }) };
var b = bundle(ip.done); if (!b) return null;
var fp = mapJson(baseUrl, b.file); if (!fp.done) return { pending: fp };
return fp.done[b.key] ? { key: b.key, d: fp.done[b.key] } : null;
}
var ICONIMG = {};
function iconSvg(set, n) { var s = (D.ICONS[set] || {})[String(n)]; return s || ''; }
function iconImg(set, n) {
var key = set + ':' + n;
if (!ICONIMG[key]) {
var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="240" height="240" color="#000">' + iconSvg(set, n).replace(/currentColor/g, '#000') + '</svg>';
ICONIMG[key] = loadImg('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg));
}
return ICONIMG[key];
}
var FONTREADY = {};
function fontReady(css) {
if (FONTREADY[css]) return FONTREADY[css];
var p = Promise.resolve();
try { if (document.fonts && document.fonts.load) p = document.fonts.load('40px ' + css).catch(function () {}); } catch (e) {}
FONTREADY[css] = p.then(function () { FONTREADY[css] = true; return true; });
return FONTREADY[css];
}
var QR = null;
function loadQR(src) {
if (window.qrcode) return Promise.resolve(window.qrcode);
if (!QR) QR = new Promise(function (res) { var s = document.createElement('script'); s.src = src; s.onload = function () { res(window.qrcode); }; s.onerror = function () { res(null); }; document.head.appendChild(s); });
return QR;
}
K.D=D;K.DASH=DASH;K.EN=EN;K.SEP_RE=SEP_RE;K.POUND_FMT=POUND_FMT;K.EMAIL=EMAIL;K.BLANK_DEFAULT=BLANK_DEFAULT;K.NUM_WORDS=NUM_WORDS;K.SWATCH=SWATCH;K.INK_DARK=INK_DARK;K.INK_LIGHT=INK_LIGHT;K.CAP=CAP;K.esc=esc;K.h=h;K.clamp=clamp;K.clone=clone;K.lc=lc;K.isObj=isObj;K.merge=merge;K.firstInt=firstInt;K.money=money;K.hash=hash;K.debounce=debounce;K.cleanLabel=cleanLabel;K.fontByN=fontByN;K.swatchFor=swatchFor;K.inkFor=inkFor;K.CFG=CFG;K.loadConfig=loadConfig;K.IMG=IMG;K.loadImg=loadImg;K.ART_INK=ART_INK;K.ARTTXT=ARTTXT;K.artBaseUrl=artBaseUrl;K.artText=artText;K.artRaster=artRaster;K.MOTIF=MOTIF;K.motifImg=motifImg;K.MAPS=MAPS;K.mapNorm=mapNorm;K.mapDist=mapDist;K.mapJson=mapJson;K.mapFind=mapFind;K.mapPlace=mapPlace;K.ICONIMG=ICONIMG;K.iconSvg=iconSvg;K.iconImg=iconImg;K.FONTREADY=FONTREADY;K.fontReady=fontReady;K.QR=QR;K.loadQR=loadQR;
})();